import { createElementFromHTML } from "./helpers";
import LazyLoad from "vanilla-lazyload";

class TrainingList {
  inputs: NodeListOf<HTMLInputElement> | null = null
  inputsInitialized: Array<{ id: string | null; name: string | null; el: HTMLInputElement; validation: string[] | null; select: HTMLSelectElement | null }> | null = null
  sectionContainer: HTMLElement | null = null
  listContainer: HTMLElement | null = null
  loader: HTMLElement | null = null
  searchBtn: HTMLElement | null = null
  filtersBtn: HTMLElement | null = null
  list: HTMLElement | null = null
  noItems: HTMLElement | null = null
  pagination: HTMLElement | null = null
  clearFiltersContainer: HTMLElement | null = null
  clearFiltersBtn: HTMLElement | null = null
  states = {
    INIT: "initialized",
    LOADING: "loading",
    DONE: "done",
    ERROR: "error",
  }
  endpoint: string | null = null
  fetching: boolean = false

  init = (): void => {
    this.inputs = document.querySelectorAll<HTMLInputElement>(".list-input");
    if (!this.inputs) return;

    this.initFields();
    this.addValidators();
    this.addEventSearchOnEnterClick();
    this.getListContainer();
    this.getEndpoint();
    this.addSearchButtonClickEvent();
    this.addChangePageEvent();
    this.addClearFiltersEvent();
  };

  initFields = (): void => {

    if (!this.inputs) return

    this.inputsInitialized = Array.from(this.inputs).map((input) => {

      let slim: HTMLSelectElement | null = null;

      // if (input.tagName.toUpperCase() === "SELECT") {

      //   slim = new SlimSelect({
      //     select: input,
      //     showSearch: false,
      //     placeholder: "wybierz wartości",
      //   }) as SlimSelect;

      //   if (input.dataset.selected && input.dataset.selected.length > 0) {
      //     slim.set(input.dataset.selected.split(","));
      //   }

      // }

      return {
        id: input.id ?? null,
        name: input.name ?? null,
        el: input as HTMLInputElement,
        validation: input.dataset?.validation?.split(",") ?? null,
        select: slim,
      };

    })
  };

  addValidators = (): void => {

    if (!this.inputsInitialized) return

    const inputsWithValidation = this.inputsInitialized.filter(
      ({ validation }) => validation
    );

    inputsWithValidation.forEach(({ el, validation }) => {

      if (!validation) return

      if (validation.includes("number_on_type")) {
        el.addEventListener("keypress", (e) => {
          if (!/^\d+$/.test(e.key)) {
            e.preventDefault();
          }
        });

        el.addEventListener("blur", (e) => {
          const target = e.target as HTMLInputElement;
          const value = Number.parseInt(target.value) as number;

          if (Number.parseInt(target.value[0]) === 0) {
            target.value = value.toString();
          }
        });
      }

      validation.find((role) => {
        if (!this.inputsInitialized) return;

        if (role.includes("lower")) {

          const field = this.inputsInitialized.filter(
            ({ name }) => name === role.split("-")[1]
          )[0].el;

          el.addEventListener("blur", (e) => {
            if (field.value) {
              if (Number.parseInt(el.value) > Number.parseInt(field.value)) {
                const value = Number.parseInt(field.value) - 1 as number;
                el.value = value.toString();
              }
            }
          });

        } else if (role.includes("higher")) {

          const field = this.inputsInitialized.filter(
            ({ name }) => name === role.split("-")[1]
          )[0].el;

          el.addEventListener("blur", (e) => {
            if (field.value) {
              if (Number.parseInt(el.value) < Number.parseInt(field.value)) {
                const value = Number.parseInt(field.value) + 1 as number;
                el.value = value.toString();
              }

            }
          });
        }
      });
    });
  };

  addEventSearchOnEnterClick = (): void => {
    if (!this.inputsInitialized || this.inputsInitialized.length == 0) return

    this.inputsInitialized[0].el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !this.fetching) this.fetchPosts();
    });
  };

  addSearchButtonClickEvent = (): void => {

    this.searchBtn?.addEventListener("click", (e) => {
      if (!this.fetching) this.fetchPosts();
    });

    this.filtersBtn?.addEventListener("click", (e) => {
      if (!this.fetching) this.fetchPosts();
    });
  };

  scrollToList = () => {
    if (!this.sectionContainer) return;

    setTimeout(
      () => {
        if (!this.sectionContainer) return;

        window.scrollTo({
          top: this.sectionContainer?.offsetTop - 150,
          behavior: "smooth",
        })
      },
      1
    );
  }

  setState = (state: string): void => {
    this.listContainer?.setAttribute("data-state", state);
  }

  getFetchUrl = (page = null): string | void => {
    if (!this.inputsInitialized) return;

    const params = this.inputsInitialized.reduce((obj, item) => {
      if (!item.el.value) return obj;
      if (item.slim) {
        const selected = item.slim.selected() as string | string[];

        if (item.name) {
          obj[item.name.replace("[]", "")] = Array.isArray(selected) ? selected.join(",") : selected;
        }

      } else {
        if (item.name) {
          obj[item.name] = item.el.value;
        }
      }
      return obj;
    }, {});

    Object.keys(params).length > 0
      ? this.clearFiltersContainer?.classList.remove("hidden")
      : this.clearFiltersContainer?.classList.add("hidden");
    if (page) Object.assign(params, { st: page });

    const query = `?${new URLSearchParams(params)}`;
    window.history.replaceState(undefined, 'undefined', query);

    return this.endpoint + query;
  };

  fetchPosts = (endpoint = null): void => {
    this.scrollToList();
    this.setState(this.states.LOADING);
    this.listContainer?.classList.remove("no-items");
    this.fetching = true;

    fetch(window.wtm_global_vars._wtm_rest + (endpoint ?? this.getFetchUrl()))
      .then((response) => response.json())
      .then(({ data: { posts, pagination } }) => {
        this.setState(this.states.DONE);

        if (this.list) {
          this.list.innerHTML = "";
        }

        if (this.pagination) {
          this.pagination.innerHTML = "";
          this.pagination?.appendChild(createElementFromHTML(pagination));
        }

        if (posts.length === 0) this.listContainer?.classList.add("no-items");

        posts?.forEach((post) => {
          const el = createElementFromHTML(post);
          this.list?.appendChild(el);
          LazyLoad.load(el.querySelector("img"), {});
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState(this.states.ERROR);
      })
      .finally(() => {
        this.fetching = false;
      });
  };

  getListContainer = (): void => {
    this.listContainer = document.querySelector<HTMLElement>(".posts") ?? null;
    this.sectionContainer = document.querySelector<HTMLElement>(".archive-training-posts-section") ?? null;
    this.loader = this.listContainer?.querySelector<HTMLElement>(".loader") ?? null;
    this.list = this.listContainer?.querySelector<HTMLElement>(".posts-list") ?? null;
    this.searchBtn = document.querySelector<HTMLElement>(".search-btn") ?? null;
    this.filtersBtn = document.querySelector<HTMLElement>(".filters-btn") ?? null;
    this.noItems = this.listContainer?.querySelector<HTMLElement>(".no-items") ?? null;
    this.pagination = this.listContainer?.querySelector<HTMLElement>(".pagination-container") ?? null;
    this.clearFiltersContainer = document.querySelector<HTMLElement>(".clear-filters-container") ?? null;
    this.clearFiltersBtn = this.clearFiltersContainer?.querySelector<HTMLElement>(".clear-filters-btn") ?? null;
    this.setState(this.states.INIT);
  };

  getEndpoint = (): void => {
    const endpoint = this.listContainer?.querySelector<HTMLElement>(".endpoint");
    if (!endpoint) return;

    this.endpoint = endpoint.innerHTML;
  };

  addSortChangeEvent = (): void => {
    if (!this.inputsInitialized) return;

    const sortSelect = this.inputsInitialized[this.inputsInitialized.length - 1];

    if (!sortSelect.slim) return;

    sortSelect.el.addEventListener("change", (e) => {
      if (!this.fetching) this.fetchPosts();
    });
  };

  addChangePageEvent = (): void => {
    this.pagination?.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      if (target.tagName.toUpperCase() === "A") {

        e.preventDefault();
        const page = target.dataset.page != 'undefined' ? target.dataset.page : null as string | null;

        if (!this.fetching && page != null) {
          this.fetchPosts(this.getFetchUrl(page));
        }
      }
    });
  };

  addClearFiltersEvent = (): void => {
    this.clearFiltersBtn?.addEventListener("click", (e) => {
      this.inputsInitialized?.forEach(({ el, slim }) => {
        el.id !== "sort" &&
          (slim instanceof SlimSelect
            ? slim.set("")
            : (el.value = ""));
      });
      this.clearFiltersContainer?.classList.add("hidden");
      this.fetchPosts();
    });
  };
}

export default TrainingList;
